/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 16.10.13
 * Time: 17:57
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ShopBackButtonTrackingEvent extends BasicTrackingEvent {
    public playerId: number;
    public date: number;
    public serviceId: number;
    public shopId: number = 1;
    public subId: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.date = this.date;
        vars.var_1 = this.serviceId;
        vars.var_2 = this.shopId;
        vars.var_data = this.subId;

        return vars;
    }
}
